import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/public/Home";
import PublicGallery from "@/pages/public/PublicGallery";
import Contact from "@/pages/public/Contact";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Consignments from "@/pages/Consignments";
import ConsignmentForm from "@/pages/ConsignmentForm";
import ConsignmentPrint from "@/pages/ConsignmentPrint";
import Bills from "@/pages/Bills";
import BillForm from "@/pages/BillForm";
import BillPrint from "@/pages/BillPrint";
import Memos from "@/pages/Memos";
import MemoForm from "@/pages/MemoForm";
import MemoPrint from "@/pages/MemoPrint";
import Parties from "@/pages/Parties";
import Trucks from "@/pages/Trucks";
import Drivers from "@/pages/Drivers";
import Users from "@/pages/Users";
import GalleryAdmin from "@/pages/GalleryAdmin";
import Inquiries from "@/pages/Inquiries";
import Reports from "@/pages/Reports";
import PendingPayments from "@/pages/PendingPayments";
import Settings from "@/pages/Settings";
import PodUpload from "@/pages/PodUpload";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="/gallery" element={<PublicGallery />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="consignments" element={<Consignments />} />
              <Route path="consignments/new" element={<ConsignmentForm />} />
              <Route path="consignments/:id/edit" element={<ConsignmentForm />} />
              <Route path="consignments/:id/print" element={<ConsignmentPrint />} />
              <Route path="bills" element={<Bills />} />
              <Route path="bills/new" element={<BillForm />} />
              <Route path="bills/:id/edit" element={<BillForm />} />
              <Route path="bills/:id/print" element={<BillPrint />} />
              <Route path="memos" element={<Memos />} />
              <Route path="memos/new" element={<MemoForm />} />
              <Route path="memos/:id/edit" element={<MemoForm />} />
              <Route path="memos/:id/print" element={<MemoPrint />} />
              <Route path="masters/parties" element={<Parties />} />
              <Route path="masters/trucks" element={<Trucks />} />
              <Route path="masters/drivers" element={<Drivers />} />
              <Route path="users" element={<Users />} />
              <Route path="site/gallery" element={<GalleryAdmin />} />
              <Route path="site/inquiries" element={<Inquiries />} />
              <Route path="reports" element={<Reports />} />
              <Route path="payments" element={<PendingPayments />} />
              <Route path="pod" element={<PodUpload />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
